import { AnalyticsEventTopic } from '~/modules/analytics/analyticsHelper';
import { MarketingAnalyticsEvent, MarketingAnalyticsEventType } from './marketingAnalyticsEventTypes';

export class MarketingAnalyticsLeadEventType extends MarketingAnalyticsEventType {
    canHandle(event: any): boolean {
        return event.topic === AnalyticsEventTopic.ANALYTICS_LEAD_EVENT;
    }

    getBody(event: any): MarketingAnalyticsEvent {
        const baseEvent = this.baseEvent(event);
        baseEvent.action = event.objectIdentifier;
        return baseEvent;
    }
}
